import { hydrateWidgets } from 'DVWebNodeUtils';
import { Atf } from 'DVWebNodeDetail/widgets/Atf';
import { Btf } from 'DVWebNodeDetail/widgets/Btf';
import { Additional } from 'DVWebNodeDetail/widgets/Additional';

// At the moment hydrateWidgets will be executed after the HTML parsed
// therefore there is no point trying to hydrate ATF and BTF separately
// TODO: Change this once hydrateWidgets can support async loading
// https://i.amazon.com/issues/PVWeb-419
hydrateWidgets(Atf);
hydrateWidgets(Btf);
hydrateWidgets(Additional);
